import {Component, ElementRef, QueryList, ViewChild, ViewChildren} from '@angular/core';
import Quill from 'quill';
import {AbstractQuillToolbarButtonComponent} from './buttons/abstract-quill-toolbar-button';

/**
 * Class for the QuillToolbarComponent. To be used inside a quill-editor component
 * @class
 * @example
 * ```html
 * <quill-editor #quill (click)="hClick($event)" item-content [placeholder]="placeholder" [readOnly]="readOnly" [modules]="getQuillModuleConfig()">
 *    <advtech-quill-toolbar #quillToolbar *ngIf="showToolbar" quill-editor-toolbar></advtech-quill-toolbar>
 * </quill-editor>
 * ```
 */
@Component({
  selector: 'advtech-quill-toolbar',
  templateUrl: './quill-toolbar.component.html',
})
export class QuillToolbarComponent {

  /**
   * Gets all the custom buttons in the toolbar
   * @type {QueryList<AbstractQuillToolbarButtonComponent>}
   */
  @ViewChildren('customButton')
  toolbarButtons: QueryList<AbstractQuillToolbarButtonComponent>;

  /**
   * The toolbar div
   */
  @ViewChild('toolbar')
  toolbar: ElementRef;

  element: ElementRef;

  /**
   * @private
   * @type {Quill}
   */
  private _quill: Quill;

  constructor(element: ElementRef) {
    this.element = element;
  }

  /**
   * Getter for the quill property
   * @returns {Quill}
   */
  get quill(): Quill {
    return this._quill;
  }

  /**
   * Setter for the quill property
   * @param {Quill} value
   */
  set quill(value: Quill) {
    this._quill = value;
  }

  /**
   * Initializes the toolbar and passes the quill instance into the custom buttons
   * @param {Quill} quill
   * @returns {void}
   */
  init(quill: Quill): void {
    this.quill = quill;
    this.toolbarButtons.toArray().forEach((elm: AbstractQuillToolbarButtonComponent) => {
      elm.init(this.quill);
    });
    this.setupQuillToolbarPickerEvents();
  }

  /**
   * Sets up listeners for the quill pickers to make them visible when clicked
   * @returns {void}
   */
  protected setupQuillToolbarPickerEvents(): void {
    this.toolbar.nativeElement.addMutationObserverToChildren(
      '.ql-picker',
      {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false,
      },
      (e) => {
        const target: HTMLElement = (e[0].target as any);
        if (target.className.indexOf('ql-expanded') === -1) {
          this.element.nativeElement.removeAttribute('style');
        }
        else {
          this.element.nativeElement.style.overflow = 'visible';
        }
      },
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/quill-toolbar.component.ts